import { render, staticRenderFns } from "./cropStaff.vue?vue&type=template&id=0b9c2c55&scoped=true"
import script from "./cropStaff.vue?vue&type=script&lang=js"
export * from "./cropStaff.vue?vue&type=script&lang=js"
import style0 from "./cropStaff.vue?vue&type=style&index=0&id=0b9c2c55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9c2c55",
  null
  
)

export default component.exports